import { Component } from "@angular/core";

@Component({
  selector: "app-card-orders",
  template: "<router-outlet></router-outlet>",
  standalone: false,
})
export class CardOrdersComponent {}
